<template>
    <div class="h-100">
        <gofix-card class="contractTree contractPropertyAria" classContent="h-100 pl-0 pr-0" v-bind:class="{'run-loading':loading.customfields}">
            <template slot="gofixCard:before_card_content">
                <div class="d-flex justify-content-between pt-16 pb-40 pl-30 pr-30">
                    <gofix-button label="Add new Custom Field +" @click="addMoreContent" outline></gofix-button>
                    <div>
                      <gofix-button class="ml-3" label="Import" @click="modals.import.open = true" outline></gofix-button>
                      <gofix-button class="ml-3" label="Save" :loading="loading.save" @click="saveCF"></gofix-button>
                    </div>
                </div>
            </template>
            <template v-if="custom_fields">
                <template v-for="(item_section, index_section) in $v.custom_fields.$each.$iter">
                    <div class="pl-30 pr-30">
                        <b-row no-gutters class="position-relative">
                            <b-col md="1">
                                <gofix-form-input-number
                                    label="Number"
                                    v-model="item_section.no.$model"
                                    :class="{ 'gofixInputError': item_section.no.$error }"
                                    required>
                                </gofix-form-input-number>
                            </b-col>
                            <b-col md="4" class="pl-20">
                                <gofix-form-input
                                    label="Name"
                                    v-model="item_section.name.$model"
                                    :class="{ 'gofixInputError': item_section.name.$error }"
                                    required>
                                </gofix-form-input>
                            </b-col>
                            <b-col md="5" class="pl-20">
                                <div class="position-relative d-flex flex-wrap checklistTypeData pr-0 pb-13">
                                    <div class="value-type">
                                        <span class="label">Value Type</span>
                                        <span class="value">{{item_section.type.$model}}</span>
                                    </div>
                                    <div class="type-options">
                                        <div v-if="item_section.type.$model === 'Reading'" class="d-flex flex-wrap">
                                            <div class="group">
                                                <span class="label">Min</span>
                                                <span class="value">{{item_section.low_threshold.$model}}</span>
                                            </div>
                                            <div class="group">
                                                <span class="label">Max</span>
                                                <span class="value">{{item_section.high_threshold.$model}}</span>
                                            </div>
                                            <div class="group">
                                                <span class="label">Unit</span>
                                                <span class="value">{{item_section.unit.$model}}</span>
                                            </div>
                                        </div>
                                        <div v-if="item_section.type.$model === 'Dropdown'" class="d-flex align-items-center">
                                            <span class="label miw-80">Value List</span>
                                            <p>
                                                <span class="value">
                                                    {{item_section.possible_values.$model.join(", ")}}
                                                </span>
                                            </p>

                                        </div>
                                    </div>
                                </div>
                            </b-col>
                            <div class="editType">
                                <gofix-button label="EDIT VALUE TYPE" @click="modalCF(item_section)" outline></gofix-button>
                                <button type="button" class="btn btnClose btn-secondary" @click="() => {
                                    modals.index_section_del = index_section;
                                    modals.delete = true;
                                }"><img src="img/close.png" alt="close"></button>
                            </div>
                        </b-row>
                    </div>
                    <hr class="mb-30" v-if="index_section < (custom_fields.length - 1)"/>
                </template>
            </template>
        </gofix-card>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Value Type" @hidden="typeData = null" hide-footer :centered="true" ref="modal-Create" v-model="modals.type">
            <b-form class="pb-20">
                <gofix-form-dropdown
                        label="Value Type"
                        :clearable="false"
                        v-model="typeDataTmp.type"
                        :options="value_types">
                </gofix-form-dropdown>
                <b-row v-show="typeDataTmp.type === 'Reading'">
                    <hr class="w-100 mt-5 mb-20">
                    <b-col md="12">
                        <gofix-form-input label="Unit" v-model="typeDataTmp.unit"></gofix-form-input>
                    </b-col>
                    <b-col>
                        <gofix-form-input-number label="Min" v-model="typeDataTmp.low_threshold" :includeThousandsSeparator="false" :allowNegative="true"></gofix-form-input-number>
                    </b-col>
                    <b-col>
                        <gofix-form-input-number label="Max" v-model="typeDataTmp.high_threshold" :includeThousandsSeparator="false" allowNegative></gofix-form-input-number>
                    </b-col>
                </b-row>
                <template v-if="typeDataTmp.type === 'Dropdown'">
                    <b-row><hr v-if="typeDataTmp.possible_values.length" class="w-100 mt-5 mb-20"></b-row>
                    <template v-for="( textService, index ) in typeDataTmp.possible_values">
                        <b-row :key="index">
                            <b-col md="11">
                                <gofix-form-input
                                    label="Value Item"
                                    v-model="typeDataTmp.possible_values[index]">
                                </gofix-form-input>
                            </b-col>
                            <b-col md="1" class="pd-0">
                                <button type="button" class="btn btnDeleteService btn-secondary left-10" @click="typeDataTmp.possible_values.splice(index, 1)"><img src="img/close.png" alt="close"></button>
                            </b-col>
                        </b-row>
                    </template>
                    <b-row>
                        <b-col md="12">
                            <gofix-button label="ADD NEW SERVICE +" @click="typeDataTmp.possible_values.push('')" outline></gofix-button>
                        </b-col>
                    </b-row>
                </template>

            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="applyCustomField" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <!-- Modal CF: Delete -->
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="remove to user" hide-footer hide-header :centered="true" v-model="modals.delete">
            <div class="center">Are you sure you want to<br/>delete <strong>This Item</strong>?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.delete = false">No</b-button>
                <b-button class="custom-btn" @click="deleteMoreContent(modals.index_section_del)">Yes</b-button>
            </b-button-group>
        </b-modal>
        <modal-import v-model="modals.import.open" @upload="uploadFileImport"/>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import { validationMixin } from 'vuelidate';
    import { required } from 'vuelidate/lib/validators';
    export default {
      name: 'contract-case-settings-custom-field',
      components: {
      },
      data() {
        return {
          modals: {
            type: false,
            check: false,
            delete: false,
            index_section_del: 0,
            import:{
              open:false
            },
          },
          value_types: ["Checkbox", "Reading", "Free text", "Dropdown", "DateTime"],
          typeDataTmp: {
            type: null,
            unit: null,
            low_threshold: null,
            high_threshold: null,
            possible_values: [],
          },
          keyMsg: 'adding',
          typeData: null,
          custom_fields: [],
          custom_fields_delete: [],
          timer: null,
          loading: {
            save_yes: false,
            save_no: false,
            customfields: false
          }
        }
      },
      mixins: [validationMixin],
      validations: {
        custom_fields: {
          $each: {
            section: {},
            no: {
              required
            },
            name: {
              required
            },
            type: {
              required
            },
            uom: {},
            unit: {},
            low_threshold: {},
            high_threshold: {},
            possible_values: {},
            index: {}
          }
        }
      },
      computed: {
        ...mapGetters({
          ClientContractID: 'ContractController/ClientContractID'
        }),
      },
      watch: {
        ClientContractID: function(val) {
          this.custom_fields = [];
          if(val && val.id) {
            this.getAttributes(val.id)
          }
        }
      },
      created() {
        this.getAttributes(this.$route.params.id)
      },
      methods: {
        modalCF(data) {
          this.modals.type = true;
          this.typeData = data;
          this.typeDataTmp = {
            type: this.typeData.type.$model,
            unit: this.typeData.unit.$model,
            low_threshold: this.typeData.low_threshold.$model,
            high_threshold: this.typeData.high_threshold.$model,
            possible_values: this.typeData.possible_values.$model || [],
          }
        },
        addMoreContent() {
          console.log(this.ClientContractID)
          this.typeData = null;
          this.custom_fields.push({
            section: '',
            no: '',
            name: '',
            uom: null,
            type: "Checkbox",
            unit: null,
            low_threshold: null,
            high_threshold: null,
            possible_values: [],
            attributable_id: this.ClientContractID.id,
            attributable_type: "App\\Data\\Models\\ContractCaseSetting",
          });
          this.$v.custom_fields.$reset()
        },
        deleteMoreContent(index) {
          if (this.custom_fields[index]) {
            if (this.custom_fields[index].id) {
              this.custom_fields_delete.push(this.custom_fields[index].id);
            }
            this.$delete(this.custom_fields, index);
            this.modals.delete = false;
          }
        },
        applyCustomField() {
          this.typeData.type.$model = this.typeDataTmp.type;
          if (this.typeDataTmp.type === "Reading") {
            this.typeData.unit.$model = this.typeDataTmp.unit;
            this.typeData.low_threshold.$model = this.typeDataTmp.low_threshold != null ? parseFloat(this.typeDataTmp.low_threshold) : null;
            this.typeData.high_threshold.$model = this.typeDataTmp.high_threshold != null ? parseFloat(this.typeDataTmp.high_threshold) : null;
          }
          if (this.typeDataTmp.type === "Dropdown") {
            this.typeData.possible_values.$model = this.typeDataTmp.possible_values;
          }

          this.modals.type = false;
        },
        saveCF() {
          if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
          }
          this.timer = setTimeout(() => {
            this.$v.custom_fields.$touch()
            if (!this.$v.custom_fields.$error) {
              this.loading.save = true;

              let request = {
                contract_id: this.$route.params.id,
                custom_fields: this.custom_fields,
                custom_fields_delete: this.custom_fields_delete,
              }

              this.$store.dispatch('CaseSettingsController/saveCaseSettingCustomFields', request)
                  .then(response => {
                    this.refreshData();
                    this.getAttributes(this.$route.params.id);
                    this.$alertNotification(this.$notificationV2(this.keyMsg, 'case_setting_custom_fields'));
                    this.keyMsg = 'editing';
                  })
                  .catch(error => {
                    this.refreshData();
                  })
            }
          }, 100)
        },
        refreshData() {
          this.modals.check = false;
          this.loading.save_yes = false;
          this.loading.save_no = false;
          this.loading.save = false;
          this.custom_fields_delete = [];
        },
        getAttributes(id) {
          this.loading.customfields = true;
          let params = {
            filter: {
              attributable_id: id,
              attributable_type: "App\\Data\\Models\\ContractCaseSetting"
            }
          }
          this.$store.dispatch('AttributeController/getItems', params)
              .then(response => {
                if (response.items) {
                  this.keyMsg = 'editing';
                  this.custom_fields = response.items;
                }
                this.loading.customfields = false;
              })
              .catch(error => {
                this.loading.customfields = false;
              })
        },
        /*--- Import ---*/
        async uploadFileImport(callback){
            const { file, resolve, reject } = await callback();
            this.$store.dispatch(`CaseSettingsController/importCaseSettingCustomFields`, {
              contract_id: this.$route.params.id,
              fileImport:  file
            })
            .then(response => {
              this.getAttributes(this.$route.params.id);
              resolve({
                result: response.data.data,
                msg_success: this.$notificationV2('importing', 'case_setting_custom_fields')
              });
            })
            .catch(err => {
              reject(err);
            })
        },
      }
    }
</script>
